type AppState = {
  showBurgerMenu: boolean;
  hasInvites: boolean;
  isLoading: boolean;
  takesLongMessage: string | null;
  hideNavbar: boolean;
};

let _state = $state<AppState>({
  showBurgerMenu: false,
  hasInvites: false,
  isLoading: false,
  takesLongMessage: null,
  hideNavbar: false
});

export const appStore = {
  get showBurgerMenu() { return _state.showBurgerMenu; },
  get hasInvites() { return _state.hasInvites; },
  get isLoading() { return _state.isLoading; },
  get takesLongMessage() { return _state.takesLongMessage; },
  get hideNavbar() { return _state.hideNavbar; },

  toggleBurgerMenu() { _state.showBurgerMenu = !_state.showBurgerMenu; },
  closeBurgerMenu() { _state.showBurgerMenu = false; },
  setHasInvites(v: boolean) { _state.hasInvites = v; },
  setLoading(v: boolean) { _state.isLoading = v; },
  setTakesLongMessage(msg: string | null) { _state.takesLongMessage = msg; },
  setHideNavbar(v: boolean) { _state.hideNavbar = v; }
};
